import { render, staticRenderFns } from "./ClmRIAdvice.vue?vue&type=template&id=04c45661&"
import script from "./ClmRIAdvice.vue?vue&type=script&lang=js&"
export * from "./ClmRIAdvice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports